import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import strategyimage from '../../assets/image/strategy-organization/strategy.jpg'
import Footer from '../../components/footer' 
export default class strategy extends Component {
    render() {
        const image=[
            {image:strategyimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','Strategy']} image={image} title="Strategy" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                “We help our clients in developing and implementing their strategy in order to improve performance and achieve growth.”
                                <br/><br/>
                                …through
                                <br/><br/>
                                <b>Vision, Mission & Destination Statement</b>
                                <br/><br/>
                                Great organizations always start with a great Vision. To achieve the Vision, organization needs to breakdown their long - term Vision into medium - term Destination Statement (Road Map).
                                <br/><br/>
                                <b>Strategy Formulation</b>
                                <br/><br/>
                                To achieve the Destination Statement, organization must formulate their strategy based on external (macro and industry) environment and their internal competitive capabilities.
                                <br/><br/>
                                <b>Balanced Scorecard Development (Corporate > Company > Division)</b>
                                <br/><br/>
                                Balanced Scorecard is a very effective methodology for Strategy Management and Performance Management. It helps organization to translate the strategy into action.
                                <br/><br/>
                                <b>Individual Performance Management System</b>
                                <br/><br/>
                                To make strategy everyone’s job, organization must link their individual Performance Management System with strategy. An effective leadership from Manager’s is needed to ensure the achievement of individual goals.
                                <br/><br/>
                                <b>Strategy Execution & Monitoring</b>
                                <br/><br/>
                                To ensure strategy is executed effectively, organization must equipped their leaders with initiative management skill and support them with dashboard system to monitor the achievement of strategy.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
